package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import compose.assets.Svg

public val Svg.Eye_closed: ImageVector
    get() {
        if (_eye_closed != null) {
            return _eye_closed!!
        }
        _eye_closed = Builder(name = "Eye_closed", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp,
                viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f,
                    strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                    pathFillType = NonZero) {
                moveTo(12.0f, 17.5f)
                curveTo(8.2f, 17.5f, 4.8f, 15.4f, 3.2f, 12.0f)
                horizontalLineTo(1.0f)
                curveTo(2.7f, 16.4f, 7.0f, 19.5f, 12.0f, 19.5f)
                reflectiveCurveTo(21.3f, 16.4f, 23.0f, 12.0f)
                horizontalLineTo(20.8f)
                curveTo(19.2f, 15.4f, 15.8f, 17.5f, 12.0f, 17.5f)
                close()
            }
        }
        .build()
        return _eye_closed!!
    }

private var _eye_closed: ImageVector? = null
